import { render, staticRenderFns } from "./emailsList.vue?vue&type=template&id=159b67ea&"
import script from "./emailsList.vue?vue&type=script&lang=js&"
export * from "./emailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports